const DIAS_SEMANA = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
];

// Parse "YYYY-MM-DD" como horário local (evita perda de dia em UTC-3)
export function parseDateLocal(value) {
  if (!value) return null;
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    const [y, m, d] = raw.slice(0, 10).split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const dt = new Date(raw);
  if (Number.isNaN(dt.getTime())) return null;
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}

// "2024-06-15" ou Date → "15/06/2024"
export function formatDatePtBR(value) {
  if (!value) return "";
  const dt = value instanceof Date ? value : parseDateLocal(value);
  if (!dt || Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString("pt-BR");
}

// Date → "15/06 - Sábado"
export function formatHeaderDate(date) {
  if (!date || Number.isNaN(date.getTime())) return "";
  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  return `${dia}/${mes} - ${DIAS_SEMANA[date.getDay()]}`;
}

// Date → "2024-06-15" para <input type="date">
export function formatDateToInput(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Aplica máscara telefone BR a string de dígitos
function maskPhoneDigits(digits) {
  if (digits.length <= 10) {
    // Fixo: (11) 1234-5678
    return digits
      .replace(/^(\d{0,2})/, "($1")
      .replace(/^(\(\d{2})(\d{0,4})/, "$1) $2")
      .replace(/^(\(\d{2}\) \d{4})(\d{0,4})/, "$1-$2");
  }
  // Celular: (11) 91234-5678
  return digits
    .replace(/^(\d{0,2})/, "($1")
    .replace(/^(\(\d{2})(\d{0,5})/, "$1) $2")
    .replace(/^(\(\d{2}\) \d{5})(\d{0,4})/, "$1-$2");
}

// onChange de input de telefone — mascara enquanto digita
export function handlePhoneChange(value) {
  const digits = String(value || "")
    .replace(/\D/g, "")
    .slice(0, 11);
  if (!digits) return "";
  return maskPhoneDigits(digits);
}

// Detecta se string parece telefone (só dígitos/espaços/hífens/parênteses)
function looksLikePhone(value) {
  const cleaned = String(value || "").replace(/[\s\-().+]/g, "");
  return /^\d{8,11}$/.test(cleaned);
}

// Para exibição: formata telefone se parecer número, caso contrário exibe como-está
export function formatContatoDisplay(value) {
  if (!value) return "";
  const str = String(value).trim();
  if (!looksLikePhone(str)) return str;
  const digits = str.replace(/\D/g, "").slice(0, 11);
  return maskPhoneDigits(digits);
}
